exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn .btn-group {\n  padding: 8px 0;\n  display: flex;\n  overflow: hidden;\n  flex-wrap: wrap;\n}\n.btn .btn-group button {\n  height: 22px;\n  line-height: 18px;\n  margin-right: 8px;\n  margin-left: 0px;\n  padding: 0 8px;\n  margin-bottom: 4px;\n}\n.btn .btn-group .ark-btn-fcdefault {\n  min-width: auto !important;\n}\n.btn .left {\n  justify-content: flex-start;\n}\n.btn .center {\n  justify-content: center;\n}\n.btn .right {\n  justify-content: flex-end;\n}\n", ""]);

// exports
